import { render, staticRenderFns } from "./CategoryTabs.vue?vue&type=template&id=0d7c8727&scoped=true"
import script from "./CategoryTabs.vue?vue&type=script&lang=js"
export * from "./CategoryTabs.vue?vue&type=script&lang=js"
import style0 from "./CategoryTabs.vue?vue&type=style&index=0&id=0d7c8727&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d7c8727",
  null
  
)

export default component.exports